import React, { useCallback, useContext, useEffect, useState } from "react";
import { genericPost } from "../../services/apiServices";
import { GET_DASHBOARD_TOP_EXPORT, } from "../../services/apiRoutes";
import { AuthContext } from "../../context/AuthContext";
import { Box, Card, CardHeader, LinearProgress, Typography } from "@mui/material";
import { t } from "../../constants/translationHelper";

function LinearProgressWithLabel({ value }) {
    return (
        <Box
            sx={{
                position: "relative",
                width: "100%",
                border: "1px solid #0058CD",
                borderRadius: "8px",
                overflow: "hidden",
            }}
        >
            <LinearProgress
                variant="determinate"
                value={value}
                sx={{
                    height: 15,
                    backgroundColor: "#FFFFFF",
                    "& .MuiLinearProgress-bar": {
                        backgroundColor: "#0058CD",
                    },
                }}
            />

            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Typography
                    sx={{
                        fontSize: "11px",
                        fontWeight: 600,
                        color: value > 50 ? "#FFFFFF" : "#0058CD",
                    }}
                >
                    {`${value.toFixed(2)}%`}
                </Typography>
            </Box>
        </Box>

    );
}

const TopCustomer = () => {
    const [topPayables, setTopPayables] = useState([]);
    const { token } = useContext(AuthContext);

    const fetchData = useCallback(async () => {
        try {
            const payload = { commanShipmentId: 1 };
            const response = await genericPost(GET_DASHBOARD_TOP_EXPORT, payload);
            if (response.data.success && response.data.data) {
                setTopPayables(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching Top Payables:", error);
        }
    }, []);
    const totalSum = topPayables.reduce(
        (sum, item) => sum + Number(item.totalAmount || 0),
        0
    );
    const highestBase = totalSum || "0";
    useEffect(() => {
        fetchData();
    }, [fetchData, token]);

    const headerStyle = {
        padding: "10px",
        borderBottom: "2px solid #ddd",
        fontSize: "12px",
        fontWeight: "700",
        color: "#000000",
    }

    return (
        <Card style={{
            padding: "0px", backgroundColor: "#F8FCF9", boxShadow: "none", color: "#000000",

        }}>
            <CardHeader title={t("Top Customer")}
                titleTypographyProps={{
                    fontWeight: 700,
                    fontSize: "16px"
                }}
            />
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    textAlign: "left",
                }}
            >
                <thead>
                    <tr style={{ background: "#EEEEEE", }}>
                        <th style={headerStyle}   >
                            {t("Company Name")}
                        </th>
                        <th style={headerStyle}   >
                            {t("Amount")}
                        </th>
                        <th style={headerStyle}   >
                            {t("Ratio in %")}
                        </th>
                        <th style={headerStyle}   >
                            {t("Progress")}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {topPayables.length > 0 ? (
                        topPayables.map((row, index) => {
                            const percentage =
                                highestBase > 0
                                    ? (Number(row.totalAmount) * 100) / highestBase
                                    : 0;
                            return (
                                <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                                    <td style={{ padding: "5px", fontSize: "12px", }}>
                                        {row.customerName}
                                    </td>
                                    <td style={{ padding: "5px", fontSize: "12px", }}>
                                        {row.currencySymbol}
                                        {parseFloat(row.totalAmount).toLocaleString()}
                                    </td>
                                    <td style={{ padding: "5px", fontSize: "12px", }}>
                                        <td style={{ padding: "0px" }}>
                                            {highestBase > 0
                                                ? ((Number(row.totalAmount) * 100) / highestBase).toFixed(2) + " %"
                                                : "0 %"}
                                        </td>
                                    </td>
                                    <td style={{ padding: "5px", fontSize: "12px", minWidth: "150px" }}>
                                        <LinearProgressWithLabel
                                            value={percentage}
                                        />
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="4" style={{ padding: "10px", textAlign: "center" }}>
                                {t("No data available")}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </Card>
    );
};
export default TopCustomer;
